const blogData = [
    {
        id: '1',
        title: 'Beneficios Científicos del Cacao para la Salud',
        image: 'https://res.cloudinary.com/dlxp4pqso/image/upload/v1748712319/cacao_salud_pgudvk.jpg',
        summary: 'Explora cómo el cacao impacta positivamente en la salud cardiovascular, cognitiva y emocional.',
        content: `
      <h2>¿Por qué el cacao es considerado un superalimento?</h2>
      <p>El cacao es rico en flavonoides, especialmente epicatequina y catequina, compuestos antioxidantes que protegen el corazón y reducen la inflamación.</p>

      <h2>Beneficios cardiovasculares</h2>
      <p>Estudios han demostrado que el consumo de cacao mejora la elasticidad arterial, reduce la presión sanguínea y disminuye el riesgo de enfermedades cardíacas (Katz et al., 2011).</p>

      <h2>Impacto en el cerebro y el estado de ánimo</h2>
      <p>El cacao promueve la liberación de serotonina y endorfinas, neurotransmisores asociados con la sensación de bienestar. Además, podría mejorar la memoria y el rendimiento cognitivo.</p>

      <h2>Referencia científica</h2>
      <p>Katz DL, Doughty K, Ali A. Cocoa and Chocolate in Human Health and Disease. Antioxid Redox Signal. 2011;15(10):2779-2811.</p>
    `
    },
    {
        id: '2',
        title: 'Cristalización de la Manteca de Cacao: Clave para un Buen Chocolate',
        image: 'https://res.cloudinary.com/dlxp4pqso/image/upload/v1748712322/cristalizacion_qsg1dv.jpg',
        summary: 'Descubre cómo la cristalización adecuada de la manteca de cacao determina la calidad del chocolate.',
        content: `
      <h2>¿Qué es la cristalización de la manteca de cacao?</h2>
      <p>La manteca de cacao puede formar diferentes tipos de cristales, pero solo uno (Forma V) es ideal para un chocolate de alta calidad.</p>

      <h2>Importancia del templado</h2>
      <p>El proceso de templado permite formar los cristales adecuados, dando como resultado un chocolate que no se derrite fácilmente y tiene un acabado brillante.</p>

      <h2>Errores comunes</h2>
      <p>Un mal templado puede generar chocolate con manchas blancas (fat bloom) o textura arenosa.</p>

      <h2>Referencia científica</h2>
      <p>Beckett ST. The Science of Chocolate. Royal Society of Chemistry; 2008.</p>
    `
    },
    {
        id: '3',
        title: 'El Cuidado en el Proceso de Transformación del Cacao',
        image: 'https://res.cloudinary.com/dlxp4pqso/image/upload/v1748712320/compuestos_tm9tps.jpg',
        summary: 'Aprende cómo preservar los compuestos beneficiosos del cacao durante su procesamiento.',
        content: `
      <h2>Importancia de una buena cosecha</h2>
      <p>La selección adecuada de vainas maduras asegura un buen contenido de precursores de sabor en los granos.</p>

      <h2>Fermentación: el corazón del sabor</h2>
      <p>Durante la fermentación, ocurren reacciones bioquímicas esenciales que desarrollan los aromas y sabores característicos del cacao.</p>

      <h2>Secado y tostado: etapas críticas</h2>
      <p>Un secado controlado previene el crecimiento de mohos, mientras que un tostado adecuado potencia los compuestos aromáticos deseables.</p>

      <h2>Referencia científica</h2>
      <p>Schwan RF, Wheals AE. The Microbiology of Cocoa Fermentation and its Role in Chocolate Quality. Crit Rev Food Sci Nutr. 2004;44(4):205-221.</p>
    `
    }
];

export default blogData;

